import {useRouter} from "next/router";
import {useEffect} from "react";
import {setCookie} from "@/utils/cookie";

/**
 * Store affiliation_id cookie when appropriate url param is found
 */
export const useAffiliationQuery = () => {
  const router = useRouter();
  const { aecid } = router.query;

  useEffect(() => {
    if (aecid) {
      setCookie('affiliation_id', aecid);
    }
  }, [aecid]);
}